import React from "react";
import Box from '@mui/material/Box'
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import StoreTitle from "../../component/StoreTitle";

const ReportHero = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>
      <Box sx={{ marginTop: -8 }}>
        <StoreTitle title="Reports" />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          marginBottom: 4,
          gap: 2,
        }}
      >
        <Button variant="outlined" onClick={() => navigate("/reports")}>
          Generate Readings
        </Button>
        <Button variant="outlined" onClick={() => navigate("/reports/records")}>
          Records
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/reports/bill-inventory")}
        >
          Bill Inventory
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/reports/customer-details")}
        >
          Customer Database
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/reports/system-logs")}
        >
          Audit Trail
        </Button>
      </Box>
    </Box>
  );
};

export default ReportHero;
